/* OCAAT Father's Day free-gift auto-add (2026).
   Spend >= £300 (excluding the gift itself) -> Tasting Kit 1
   (variant 57684023902591) is auto-added to the cart; a store-level automatic
   discount ("Fathers Day: Free Tasting Kit 1 over £300") makes that line £0.
   The gift removes itself if the cart later drops back below £300.

   Reversible: delete this file AND its <script> include in layout/theme.liquid,
   then end the matching automatic discount in Admin. It also self-disables after
   the discount's end timestamp below, so a stale include can't keep gifting.

   Integrates with the custom drawer in assets/cart.js, which exposes
   window.OCAATCart.refresh() and performs every cart mutation through fetch(). */
(function () {
  'use strict';

  var GIFT_VARIANT = 57684023902591;          // Tasting Kit 1 (£45) — Ben Nevis / Glentauchers / Auchroisk
  var KIT_PRODUCT  = 15697970430335;          // "Interactive Tasting Kits" product — excluded from the £300 bottle threshold
  var THRESHOLD    = 30000;                    // £300.00 in minor units (GBP-only store)
  var PROP_KEY     = '_free_gift';             // leading underscore => hidden from the customer
  var PROP_VAL     = 'fathers-day-2026';
  var END_TS       = Date.parse('2026-06-21T22:59:59Z'); // matches the automatic discount endsAt

  var working = false;
  var pending = false;

  function expired() { return !isNaN(END_TS) && Date.now() > END_TS; }

  function isGift(item) {
    return item.variant_id === GIFT_VARIANT &&
           item.properties && item.properties[PROP_KEY] === PROP_VAL;
  }

  function qualifyingSubtotal(cart) {
    // The store discount requires £300 of BOTTLES (Grandfather/Pendulum/Chronograph
    // collections), so exclude every tasting-kit line — the gift itself and any
    // kit the customer paid for — to stay in lockstep with the discount.
    return (cart.items || []).reduce(function (sum, item) {
      return item.product_id === KIT_PRODUCT ? sum : sum + (item.original_line_price || 0);
    }, 0);
  }

  function findGift(cart) {
    var items = cart.items || [];
    for (var i = 0; i < items.length; i++) { if (isGift(items[i])) return items[i]; }
    return null;
  }

  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('cart ' + r.status); return r.json(); });
  }

  function addGift() {
    var props = {}; props[PROP_KEY] = PROP_VAL;
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: GIFT_VARIANT, quantity: 1, properties: props }] })
    }).then(function (r) { if (!r.ok) throw new Error('add ' + r.status); return r.json(); });
  }

  function setGiftQty(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { if (!r.ok) throw new Error('change ' + r.status); return r.json(); });
  }

  function repaint() {
    if (window.OCAATCart && typeof window.OCAATCart.refresh === 'function') {
      try { window.OCAATCart.refresh(); } catch (e) { /* noop */ }
    }
  }

  function reconcile() {
    if (expired()) return;
    if (working) { pending = true; return; }   // coalesce bursts of cart changes
    working = true; pending = false;
    getCart().then(function (cart) {
      var sub = qualifyingSubtotal(cart);
      var gift = findGift(cart);
      if (sub >= THRESHOLD && !gift)        { return addGift().then(repaint); }
      if (gift && sub < THRESHOLD)          { return setGiftQty(gift.key, 0).then(repaint); }
      if (gift && gift.quantity !== 1)      { return setGiftQty(gift.key, 1).then(repaint); } // keep the freebie to one unit
    }).catch(function () { /* preview/offline or transient error: leave cart untouched */ })
      .then(function () { working = false; if (pending) { reconcile(); } });
  }

  /* React to cart mutations the theme makes (PDP add, drawer qty/remove, /cart page).
     Our own add/change calls run while working === true, so they don't re-trigger. */
  var _fetch = window.fetch;
  window.fetch = function (input) {
    var url = (input && input.url) ? input.url : ('' + input);
    var p = _fetch.apply(this, arguments);
    if (!working && /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url)) {
      p.then(function () { setTimeout(reconcile, 80); }, function () {});
    }
    return p;
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(reconcile, 400); });
  } else {
    setTimeout(reconcile, 400);
  }
})();
